import { z } from 'zod';

export const emailSchema = z.string().min(1, 'Required field').email('Invalid email format');

export const optionalEmailSchema = z.string().email('Invalid email format').or(z.literal(''));

export type Email = z.infer<typeof emailSchema>;
